import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { SPI_WIDGETS } from './spi-panel/widgets/constants';

export const SUMMARY_PANEL_TYPE = {
  SPI: 'SPI',
  NETWORK: 'NETWORK',
};

const DEFAULT_WIDGET_LIST = {
  EI: {
    [SUMMARY_PANEL_TYPE.SPI]: SPI_WIDGETS,
  },
  AI: {
    [SUMMARY_PANEL_TYPE.SPI]: [],
  },
  APP: {
    [SUMMARY_PANEL_TYPE.SPI]: SPI_WIDGETS,
    [SUMMARY_PANEL_TYPE.NETWORK]: [],
  },
  ODP: {
    [SUMMARY_PANEL_TYPE.SPI]: [],
  },
  ECO_SERVER: {
    [SUMMARY_PANEL_TYPE.SPI]: SPI_WIDGETS,
  },
};

export const DEFAULT_WIDGETS: { [key: string]: any[] } = DEFAULT_WIDGET_LIST[CURRENT_PRODUCT_MODE];
